import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { baseUrl } from "constant";
import { RootState } from "store/store";
import { handlingErrorResponse } from "utils/HandlingErrorResponse";
import { getAuthToken } from "utils/getAuthToken";
import { IAddEditResourceInfo, IAddResourceAllocationInfo, IGetResourceDetailParamsType } from "../types";
import { ResourceEndpointConst, deleteResource, getResourceById, getResourceUserHistory } from "./const";
import {
    IResourceAllocationListResponse,
    IResourceByIdResponseType,
    IResourceListRequest,
    IResourceListResponse,
    IResourceUserHistoryResponseType,
    IResponseType
} from "./type";

export const ResourcesApi = createApi({
    reducerPath: "resourcesApi",
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getAuthToken(getState() as RootState)
            if (token) {
                headers.set('Authorization', `Bearer ${token}`)
            }
            return headers
        },
    }),
    tagTypes: ['Resource'],
    endpoints: (builder) => ({
        GetResourceList: builder.mutation<IResourceListResponse, IResourceListRequest>({
            query: (userReq) => ({
                url: ResourceEndpointConst.GetResourceListUrl,
                method: 'POST',
                body: userReq
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'Resource', id: 'GetResourceList' }],
        }),
        AddEditResource: builder.mutation<IResponseType<string>, IAddEditResourceInfo>({
            query: (userReq) => ({
                url: ResourceEndpointConst.AddEditResourceUrl,
                method: 'POST',
                body: userReq.resourceObj
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'Resource', id: 'GetResourceList' }],
        }),
        AddResourceAllocation: builder.mutation<IResponseType<string>, IAddResourceAllocationInfo>({
            query: (userReq) => ({
                url: ResourceEndpointConst.AddResourceAllocationUrl,
                method: 'POST',
                body: userReq.resourceAllocationObj
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'Resource', id: 'GetResourceList' }],
        }),
        GetResourceUserHistory: builder.query<IResponseType<IResourceUserHistoryResponseType[]>, IGetResourceDetailParamsType>({
            query: (params) => getResourceUserHistory(params),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'Resource', id: 'GetResourceList' }]
        }),
        GetResourceById: builder.query<IResponseType<IResourceByIdResponseType>, IGetResourceDetailParamsType>({
            query: (params) => getResourceById(params),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'Resource', id: 'GetResourceList' }]
        }),
        DeleteResource: builder.mutation<void, number>({
            query: resourceId => ({
                url: deleteResource(resourceId),
                method: 'DELETE',
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'Resource', id: 'GetResourceList' }]
        }),
        GetAllocatedResourceList: builder.mutation<IResourceAllocationListResponse, IResourceListRequest>({
            query: (userReq) => ({
                url: ResourceEndpointConst.GetAllocatedResourceListUrl,
                method: 'POST',
                body: userReq
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'Resource', id: 'GetResourceList' }],
        }),
    })
})
